import { fromClass, fromClassArray } from "fw-model";
import { GaugeStatSummary, QueueStatSummary, TimingStatSummary } from "./foundatio";

export class ContactsAppMetrics {
    Activities: number;
    Contacts: number;
    ContactAttachments: number;
}

export class ContactsElasticStatSummary {
    Index: string;
    Health: string;
    Status: string;
    TotalDocuments: number;
    TotalDeleted: number;
    TotalStorageSize: number;
}

export class ContactsDataSourceStatSummary {
    total: number;
    @fromClass queue: QueueStatSummary;
    @fromClass requests: GaugeStatSummary;
    @fromClass requestTime: TimingStatSummary;
}

export class ContactsSystemMetrics {
    @fromClassArray(ContactsElasticStatSummary) Elasticsearch: ContactsElasticStatSummary[] = [];
    Queues: { [key: string]: QueueStatSummary } = {};
    dataSourcePulls: { [key: string]: ContactsDataSourceStatSummary };
    dataSourceImports: { [key: string]: ContactsDataSourceStatSummary };
}
